import { Component } from '@angular/core';
import { AlleviateNauseaAndVomitingComponent } from '@consultation-upsells/alleviate-nausea-and-vomiting/alleviate-nausea-and-vomiting.component';

@Component({
  selector: 'app-alleviate-nausea-and-vomiting-peptide',
  imports: [AlleviateNauseaAndVomitingComponent],
  templateUrl: './alleviate-nausea-and-vomiting-peptide.component.html',
})
export class AlleviateNauseaAndVomitingPeptideComponent {}
